import { BOX_PDF } from '@flow/libs/agreement/constants';

import { SIGNATURE_FIELD } from '@app/components/contract-boxes/constants';
import { getVisibility, getSectionRule } from '@app/components/contract-boxes/box-wrapper/helpers';

import {
  PDFOverlayFieldSignatureData,
  PDFBox,
} from '@flow/libs/data-validators/entity-schemas/document-box/pdf-box';
import type { Box } from '@flow/libs/data-validators/entity-schemas/document-box';
import { createDataFieldExternalKeyValueMap } from '@app/reducers/helpers/current-contract';

// Extracts unassigned signature fields from an agreement's PDF boxes
export const getUnassignedSignatureFields = (agreement: Oneflow.Agreement) => {
  if (!agreement) {
    return [];
  }

  const pdfBoxes = agreement.boxes?.filter((box) => box.type === BOX_PDF) as PDFBox[];

  if (!pdfBoxes || pdfBoxes.length === 0) {
    return [];
  }

  // Create a map of external keys to their values from agreement data
  // This helps determine visibility of fields based on data field values
  const dataFieldExternalKeyValueMap = createDataFieldExternalKeyValueMap(agreement?.data);

  const unassignedFields: PDFOverlayFieldSignatureData[] = [];

  const isUnassigned = (data: any): data is PDFOverlayFieldSignatureData =>
    data?.key === SIGNATURE_FIELD && data?.value?.participant === null;

  pdfBoxes.forEach((box) => {
    const rule = getSectionRule(box as Box);
    const isVisible = getVisibility(rule, dataFieldExternalKeyValueMap);

    if (!isVisible) {
      return;
    }

    box.content?.data?.forEach((data) => {
      if (isUnassigned(data)) {
        unassignedFields.push(data);
      }
    });
  });

  return unassignedFields;
};
